import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ease = [0.16, 1, 0.3, 1];

/**
 * Visible, crawlable brand paragraph for AEO / AI-search / SEO. This is
 * rendered as real HTML text (not CSS-hidden, not inside an image) so search
 * engines and LLMs can index the factual brand description.
 */
export default function AboutBrand() {
  return (
    <section
      className="relative w-full px-6 md:px-16 py-16 md:py-24"
      style={{ background: "var(--cream)" }}
      data-testid="about-brand-section"
    >
      <div className="mx-auto max-w-4xl">
        <div className="frame flex items-center justify-between px-5 py-3">
          <span
            className="text-[0.58rem] track-sm uppercase"
            style={{ color: "var(--paper-dim)" }}
          >
            04 / The Brand
          </span>
          <span
            className="text-[0.58rem] track-sm uppercase"
            style={{ color: "var(--paper-faint)" }}
          >
            Ageing-Focused Skincare
          </span>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease }}
          className="mt-10 md:mt-14"
        >
          <h2
            className="headline text-3xl sm:text-4xl lg:text-5xl"
            data-testid="about-brand-heading"
          >
            About Evove Skincare
          </h2>
          <p
            className="mt-6 text-base md:text-[1.02rem] leading-relaxed"
            style={{ color: "var(--paper-dim)" }}
            data-testid="about-brand-paragraph"
          >
            Evove Skincare is an ageing-focused skincare brand for Indian skin,
            combining clinically studied actives with advanced multi-pathway
            delivery systems to support barrier repair, pigmentation
            correction, skin recovery and healthier-looking skin over time.
          </p>

          <Link
            to="/skin-longevity-triple-serum"
            className="mt-8 inline-flex items-center gap-2 text-[0.78rem] track-sm uppercase font-semibold"
            style={{ color: "var(--paper)" }}
            data-testid="link-to-product-page"
          >
            Explore the Skin Longevity Triple Serum
            <ArrowRight size={14} strokeWidth={1.8} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
